module.exports = __webpack_public_path__ + "img/Beneficio_3.e5d05407.webp";